import React, { Component } from 'react';
import _ from 'lodash';
import tinycolor from 'tinycolor2';

import DisplayComponent from './DisplayComponent';

import {
  isLbsMeet,
  getMeetUnits
} from 'util/meetHelper';

import {
  getAvailablePlates,
  getPlates
} from 'util/barLoad';

const plateConfigKg = {
  plate_50: {
    text: ['5', '0'],
    width: 40,
    height: 200,
    fontSize: 24
  },
  plate_25: {
    text: ['2', '5'],
    width: 30,
    height: 200,
    fontSize: 24
  },
  plate_20: {
    text: ['2', '0'],
    width: 25,
    height: 200,
    fontSize: 24
  },
  plate_15: {
    text: ['1', '5'],
    width: 22,
    height: 180,
    fontSize: 24
  },
  plate_10: {
    text: ['1', '0'],
    width: 20,
    height: 160,
    fontSize: 20
  },
  plate_5: {
    text: ['5'],
    width: 16,
    height: 150,
    fontSize: 18
  },
  plate_2_5: {
    text: ['2', '•', '5'],
    width: 16,
    height: 125,
    fontSize: 16
  },
  plate_2: {
    text: ['2'],
    width: 16,
    height: 115,
    fontSize: 16
  },
  plate_1_5: {
    text: ['1', '•', '5'],
    width: 16,
    height: 105,
    fontSize: 16
  },
  plate_1_25: {
    text: ['1', '•', '2', '5'],
    width: 16,
    height: 100,
    fontSize: 16
  },
  plate_1: {
    text: ['1'],
    width: 16,
    height: 90,
    fontSize: 15
  },
  plate_0_5: {
    text: ['0', '•', '5'],
    width: 16,
    height: 80,
    fontSize: 15
  },
  plate_0_25: {
    text: ['0', '•', '2', '5'],
    width: 16,
    height: 65,
    fontSize: 12
  }
};

const plateConfigLbs = {
  plate_100: {
    text: ['1', '0', '0'],
    width: 40,
    height: 200,
    fontSize: 24
  },
  plate_55: {
    text: ['5', '5'],
    width: 35,
    height: 200,
    fontSize: 24
  },
  plate_45: {
    text: ['4', '5'],
    width: 30,
    height: 200,
    fontSize: 24
  },
  plate_35: {
    text: ['3', '5'],
    width: 25,
    height: 180,
    fontSize: 24
  },
  plate_25: {
    text: ['2', '5'],
    width: 22,
    height: 155,
    fontSize: 24
  },
  plate_10: {
    text: ['1', '0'],
    width: 20,
    height: 125,
    fontSize: 20
  },
  plate_5: {
    text: ['5'],
    width: 16,
    height: 105,
    fontSize: 18
  },
  plate_2_5: {
    text: ['2', '•', '5'],
    width: 16,
    height: 90,
    fontSize: 16
  },
  plate_1_25: {
    text: ['1', '•', '2', '5'],
    width: 16,
    height: 80,
    fontSize: 16
  },
  plate_0_5: {
    text: ['0', '•', '5'],
    width: 16,
    height: 75,
    fontSize: 15
  },
  plate_0_25: {
    text: ['0', '•', '2', '5'],
    width: 16,
    height: 65,
    fontSize: 12
  }
};

class LoadingChart extends Component {

  render() {
    const { meet, currentAttempt, id, currentLifter } = this.props;
    let isError = false;
    let plates;

    let plateConfig = plateConfigKg;

    if(isLbsMeet(meet)) {
      plateConfig = plateConfigLbs;
    }

    _.merge(plateConfig, meet.plates);
    const availablePlates = getAvailablePlates(plateConfig);
    try {
      if(currentAttempt && !_.isEmpty(currentAttempt)) {
        plates = getPlates(currentAttempt.weight, availablePlates, this.props.platform);
      } else {
        // if no attempt selected show all plates loaded
        plates = availablePlates;
      }

    } catch(e) {
      isError = true;
    }

    return (
      <DisplayComponent style={{top: 0, left: 900}} id={id}>
        {({ sizeMultiplier }) => {
          if(isError) {
            return (
              <div style={{color: 'red', fontSize: 42 * sizeMultiplier}}>
                Unable to load {currentAttempt.weight} {getMeetUnits(meet)} with available plates.
              </div>
            );
          }

          const liftName =  _.get(currentAttempt, 'liftName', 'Lift');
          const rackHeight = _.get(currentLifter, `${liftName}RackHeight`, '');
          const lifterName = _.get(currentLifter, 'name', 'AAAAAAA AAAAAAA');

          const style = {
            padding: sizeMultiplier * 12,
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'center',
            alignItems: 'center',
            height: sizeMultiplier * 220
          };

          const rackHeightWrapperStyle = {
            width: 100 * sizeMultiplier
          };

          const rackHeightStyle = {
            fontSize: _.min([(220 * sizeMultiplier) / _.size(rackHeight), 28 * sizeMultiplier])
          };

          const liftInfoStyle = {
            fontSize: 18 * sizeMultiplier
          };

          const lifterNameWrapperStyle = {
            width: 100 * sizeMultiplier
          };

          const lifterNameStyle = {
            fontSize: _.min([(160 * sizeMultiplier) / _.size(lifterName), 14 * sizeMultiplier])
          };

          const leftBarStyle = {
            borderTopLeftRadius: 7 * sizeMultiplier,
            borderBottomLeftRadius: 7 * sizeMultiplier,
            width: 90 * sizeMultiplier,
            height: 16 * sizeMultiplier,
            backgroundColor: '#595959',
            paddingRight: 4 * sizeMultiplier,
            fontSize: 14 * sizeMultiplier,
          };

          const leftBarLabelStyle = {
            fontSize: 12 * sizeMultiplier,
            paddingRight: 4 * sizeMultiplier,
          };

          const collarStyle = {
            marginRight: 2,
            borderRadius: 5 * sizeMultiplier,
            width: 30 * sizeMultiplier,
            height: 30 * sizeMultiplier,
            backgroundColor: '#595959'
          };

          const rightBarStyle = {
            borderTopRightRadius: 7 * sizeMultiplier,
            borderBottomRightRadius: 7 * sizeMultiplier,
            width: 20 * sizeMultiplier,
            height: 16 * sizeMultiplier,
            backgroundColor: '#595959'
          };

          const attemptChangeInProgressStyle = {
            fontSize: 40 * sizeMultiplier,
          };

          return (
            <div className="loading-chart" style={style}>
              {!!this.props.platform.attemptChangeInProgress &&
                <div className="attempt-change-overlay" style={attemptChangeInProgressStyle}>
                  <div>ATTEMPT</div><div>CHANGE</div><div>IN PROGRESS</div>
                </div>
              }
              <div className="rack-height-wrapper" style={rackHeightWrapperStyle}>
                <div className="rack-height" style={rackHeightStyle}>{rackHeight}</div>
              </div>
              <div className="lifter-name-wrapper" style={lifterNameWrapperStyle}>
                <div className="lifter-name" style={lifterNameStyle}>{lifterName}</div>
                <div className="lifter-name" style={liftInfoStyle}>{_.capitalize(liftName)} {_.get(currentAttempt, 'attemptNumber')}</div>
                <div className="lifter-name" style={liftInfoStyle}>
                  { _.get(currentAttempt, 'weight', '000') }{getMeetUnits(meet)}
                </div>
              </div>
              <div className="left-bar" style={leftBarStyle}>{ this.props.platform.barAndCollarsWeight &&  <React.Fragment><div style={leftBarLabelStyle}>Bar & Cols</div> {this.props.platform.barAndCollarsWeight}</React.Fragment>}</div>
              {
                _.map(plates, (plate, index) => {
                  const plateStyle = {
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    alignItems: 'center',
                    backgroundColor: plate.color,
                    borderWidth: sizeMultiplier,
                    borderStyle: 'solid',
                    borderColor: 'gray',
                    marginRight: 2 * sizeMultiplier,
                    marginLeft: 2 * sizeMultiplier,
                    borderRadius: 5 * sizeMultiplier,
                    color: tinycolor.mostReadable(plate.color, ['white', 'black']).toHexString(),
                    width: plate.width * sizeMultiplier,
                    height: plate.height * sizeMultiplier,
                    fontSize: plate.fontSize * sizeMultiplier
                  };
                  return (
                    <div style={plateStyle} key={index}>
                      {
                        _.map(plate.text, (char, index) => {
                          return (
                            <div key={`${char}-${index}`}>
                              {char}
                            </div>
                          );
                        })
                      }
                    </div>
                  );
                })
              }
              <div style={collarStyle} />
              <div style={rightBarStyle} />
            </div>
          );
        }}
      </DisplayComponent>
    );
  }
}

export default LoadingChart;
